module.exports = __webpack_public_path__ + "static/media/hip_abduction_machine.8660a214.png";